<script>
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return null;
                }
            },
            profile: {
                required: true,
            },
            glass: {
                required: true,
            },
            modifier_class: {
                default(){
                    return '_wide';
                }
            },
        },
        computed: {
            passed_filter() {
                return this.variable_ready(this.fabricator, this.profile, this.glass);
            },
            thumbURL(){
                return '/thumb/profile/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/bead?profile=' + this.profile + '&glass=' + this.glass;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.profile + '_' + this.glass;
            },
        },
        watch: {
            'cache_key': function (newVal, oldVal) {
                this.update_options();
            },
        },
    }
</script>
